import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const CALENDLY_URL = 'https://calendly.com/contact-bankkimedia/30min';

const HowItWorks = () => {
  const { t } = useTranslation();
  const h = t('home.howItWorks', { returnObjects: true });

  return (
    <section data-testid="how-it-works" className="py-16 md:py-24 border-t border-white/5">
      <div className="container-custom max-w-4xl">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold font-['Syne'] text-white">{h.title}</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {h.steps.map((step, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="text-center p-6">
              <div className="w-14 h-14 mx-auto mb-5 rounded-full border border-[#c8ff00]/20 bg-[#c8ff00]/5 flex items-center justify-center">
                <span className="text-[#c8ff00] text-lg font-bold font-['Syne']">{step.num}</span>
              </div>
              <h3 className="text-white text-lg font-bold font-['Syne'] mb-2">{step.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{step.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
            <motion.span whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }} className="inline-flex items-center gap-2 px-10 py-4 bg-[#c8ff00] text-black font-bold rounded-full text-lg hover:bg-[#d4ff33] transition-colors">
              {h.cta}
              <ArrowRight className="w-5 h-5" />
            </motion.span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
